<template>
  <a-layout>
    <a-space>
      <a-input v-model="containerNo" :addon-before="$t('business.label.containerNo')" allowClear @pressEnter="getData"/>
      <a-input v-model="caseNumber" :addon-before="$t('business.label.caseOutBound')" :disabled="numberDisabled"/>
      <a-input v-model="changeBoxNumber" :addon-before="$t('business.label.seedingReplenishmentExchangeBox')" :disabled="numberDisabled"/>
      <a-input v-model="tailBoxExchangeBoxNumber" :addon-before="$t('business.label.tailBoxExchangeBox')" :disabled="numberDisabled"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="scrollY"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="taskType" title="business.label.taskType"/>
      <vxe-column field="container.no" title="business.label.sourceContainer"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="customer.no" title="business.label.customerNo"/>
      <vxe-column field="customer.name" title="business.label.customerName"/>
    </vxe-table>
  </a-layout>
</template>
<script>
import { findAll } from '@/api/Api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
    name: 'exchangeBoxList',
    data() {
      return {
        containerNo: undefined,
        caseNumber: undefined,
        changeBoxNumber: undefined,
        tailBoxExchangeBoxNumber: undefined,
        numberDisabled: true,
        data: [],
        loading: false,
        scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.81)// 表格竖向滚动条
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        this.loading = true
        findAll('exchangeListFactory', {'container.no': this.containerNo})
          .then((res) => {
            if (res.success) {
              let arr1 = []
              let arr2 = []
              let arr3 = []
              res.result.forEach(item => {
                if (item.taskType === '分播换箱' || item.taskType === '补货换箱') {
                  arr1.push(item)
                } else if (item.taskType === '尾箱换箱') {
                  arr2.push(item)
                } else if (item.taskType === '整箱出库') {
                  arr3.push(item)
                }
              })
              this.changeBoxNumber = arr1.length
              this.tailBoxExchangeBoxNumber = arr2.length
              this.caseNumber = arr3.length
              this.data = res.result
            }
          }).finally(() => {
          this.loading = false
        })
      },
      dblclick(row) {
        this.$emit('dblclick', {containerNo: row.container.no})
      }
    }
  }
</script>
